import { observer } from 'mobx-react';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import { Form as BsForm, Button } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import SlidingPanel from 'react-sliding-side-panel';
import assignCode from '../../assets/Images/code.svg';
import assignGroup from '../../assets/Images/group.svg';
import { ModuleType } from '../../constants/enums/module-type-enum';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import { useStore } from '../../contexts/store-provider';
import {
  GroupDefaultSortColumnOrder,
  GroupFilterInitialState,
} from '../../core/initialState/filter-initial-state';
import { isOperationPermittedRoleBase } from '../../helpers/action-permission-helper';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import { IUpdateGroupSetting } from '../../models/forms/IAddUpdateGroupSetting';
import IPageInfo, { IOption, IPageLimitInfo } from '../../models/ICommon';
import IDefaultColumSortOrder from '../../models/IDefaultColumSortOrder';
import { IGroupFilter } from '../../models/IGroupFilter';
import LoaderButton from '../../shared-components/button/loader-button';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Grid from '../../shared-components/Grid/Grid';
import Pagination from '../../shared-components/Grid/Pagination';
import Header from '../../shared-components/header/header';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../shared-components/popup/delete/delete-popup-hoc';
import {
  CloseSidePanelIcon,
  LeftArrowMove,
  NoGroupIcon,
  RefreshIcon,
  RightArrowMove,
  SelectedGroupNoDataIcon,
} from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
import AddEditCode from './components/add-edit-code';
import AddEditGroupSetting from './components/add-edit-group-setting';
import FilterComponent from './components/filter';
import GroupSettingDetails from './group-setting-details';
import './group-setting.css';
import AddEditGroupCodePopupHOC from './hoc/add-edit-group-code-popup-hoc';
import AddEditGroupSettingPopupHOC from './hoc/add-edit-group-setting-popup-hoc';
import noMessageIcon from '../../assets/Images/no-group.png';

const GroupSetting = (props: any) => {
  const { preferencesStore, groupSettingStore } = useStore();

  const {
    GetGroupSettingListService,
    allGroupSettings,
    getAllGroupSettingState,
    groupSettingList,
    deleteGroupSettingState,
    resetGroupSettingDetail,
    DeleteGroupSettingService,
    resetDeleteGroupSetting,
    addUpdateGroupSettingState,
    resetAddUpdateGroupSettingState,
    groupSettingState,
    allGroupOptions,
    GetAllGroupSettingService,
    GetGroupSettingByNameService,
    groupsByNameList,
    getGroupSettingByNameState,
    resetGetAllGroupSettingState,
    UpdateGroupSettingService,
    updateGroupSettingState,
    resetUpdateGroupSettingState,
    getAllGroupNameSettingState,
    addGroupCodeState,
    resetAddGroupCodeState,
    resetGroupSettingByNameState,
    isGroupActive,
  } = groupSettingStore;

  const {
    userSetting,
    setUserSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;

  let lang: string;
  const allGroupOptionsData = allGroupOptions;

  enum PartitionEnum {
    left,
    right,
  }

  const [allGroupSettingsListData, setAllGroupSettingsListData] = useState<
    any[]
  >([]);
  const [selectedGroupSettingDetails, setSelectedGroupSettingDetails] =
    useState<any[]>([]);
  const MAX_RECORDS_LENGTH = 16;
  const [rightSelectedData, setRightSelectedData] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedCodeIds, setSelectedCodeIds] = useState<any[]>([]);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState(0);
  const [openPanel, setOpenPanel] = useState(false);
  const [showGroupItems, setShowGroupItems] = useState(false);
  const [isGroupSelected, setIsGroupSelected] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [selectedGroup, setSelectedGroup] = useState('');
  const [selectedIds, setSelectedIds] = useState<any[]>([]);
  const [selectedRightIds, setSelecteRightIds] = useState<any[]>([]);
  const [filterObj, setFilterObj] = useState<IGroupFilter>(
    GroupFilterInitialState
  );
  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    GroupDefaultSortColumnOrder
  );
  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);
  const pageLimitOptions: Array<number> = [10, 20, 50, 100];
  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });
  const [groupName, setGroupName] = useState('');

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const createQueryString = (filter: IGroupFilter): string => {
    return Object.entries(filter)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('#');
  };

  const getGroupSettingsServiceHandler = (
    filterQuery?: string,
    isFilter = false
  ) => {
    if (!filterQuery) {
      filterQuery = createQueryString({
        ...filterObj,
        Column: columSortOrder.dataField,
        Order: columSortOrder.order,
      });
    }
    if (!isFilter) {
      GetGroupSettingListService(
        pageInfo.currentPage,
        pageLimitInfo.pageLimit,
        Number(getTenantIdFromLocalStorage()),
        encodeURIComponent(filterQuery)
      );
    } else {
      GetGroupSettingListService(
        1,
        pageLimitInfo.pageLimit,
        Number(getTenantIdFromLocalStorage()),
        encodeURIComponent(filterQuery)
      );
    }
  };

  function initState() {
    getGroupSettingsServiceHandler();
    setIsGroupSelected(false);
    setShowGroupItems(false);
  }

  useEffect(() => {
    getGroupSettingsServiceHandler();
    setSelectedGroupSettingDetails([]);
  }, []);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      totalPages: groupSettingList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [groupSettingList]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      const filter = createQueryString({
        ...filterObj,
        Column: columSortOrder.dataField,
        Order: columSortOrder.order,
        IsAssigned: !showGroupItems ? '' : isGroupSelected ? 'false' : 'true',
      });
      getGroupSettingsServiceHandler(filter);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      const filter = createQueryString({
        ...filterObj,
        Column: columSortOrder.dataField,
        Order: columSortOrder.order,
        IsAssigned: !showGroupItems ? '' : isGroupSelected ? 'false' : 'true',
      });
      getGroupSettingsServiceHandler(filter);
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (lang && language !== lang) {
      getGroupSettingsServiceHandler();
    }
  }, [language]);

  useEffect(() => {
    if (
      selectedIds.length + selectedGroupSettingDetails.length >
      MAX_RECORDS_LENGTH
    ) {
      toast.error(formatMessage('max_records_allowed'));
    }

    if (
      isGroupSelected &&
      selectedIds.length > 0 &&
      selectedIds.length + selectedGroupSettingDetails.length ===
        MAX_RECORDS_LENGTH
    ) {
      toast.error(formatMessage('max_records_allowed'));
    }

    if (selectedCodeIds.length > selectedIds.length) {
      toast.error(formatMessage('group_already_assigned'));
    }
  }, [selectedIds, selectedCodeIds]);

  useEffect(() => {
    if (updateGroupSettingState.success) {
      toast.success(formatMessage('updated_success'));
      resetUpdateGroupSettingState();
      initState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateGroupSettingState.success]);

  useEffect(() => {
    if (addUpdateGroupSettingState.success) {
      setSelectedCodeIds([]);
      setSelectedRows([]);
      resetAddUpdateGroupSettingState();
      getGroupSettingsServiceHandler();
      setSelectedIds([]);
      setSelectedCodeIds([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateGroupSettingState.success]);

  useEffect(() => {
    if (addUpdateGroupSettingState.error) {
      toast.error(formatMessage(addUpdateGroupSettingState.error));
      resetAddUpdateGroupSettingState();
      initState();
    }
  }, [addUpdateGroupSettingState.error]);

  useEffect(() => {
    if (addGroupCodeState.success) {
      setSelectedCodeIds([]);
      setSelectedRows([]);
      resetAddGroupCodeState();
      getGroupSettingsServiceHandler();
      setSelectedIds([]);
      setSelectedCodeIds([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addGroupCodeState.success]);

  useEffect(() => {
    if (addGroupCodeState.error) {
      toast.error(formatMessage(addGroupCodeState.error));
      resetAddGroupCodeState();
      initState();
    }
  }, [addGroupCodeState.error]);

  useEffect(() => {
    if (deleteGroupSettingState.success) {
      toast.success(formatMessage('deleted_success'));
      props.deletePopupToggleHandler();
      resetDeleteGroupSetting();
      getGroupSettingsServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteGroupSettingState.success]);

  useEffect(() => {
    if (getAllGroupSettingState.success) {
      setAllGroupSettingsListData(allGroupSettings);
      resetGetAllGroupSettingState();
    }
  }, [getAllGroupSettingState.success]);

  useEffect(() => {
    if (getGroupSettingByNameState.success) {
      setAllGroupSettingsListData(
        !isGroupSelected
          ? allGroupSettingsListData
          : allGroupSettingsListData.filter((item) => item?.Group.length === 0)
      );
      setSelectedGroupSettingDetails([...groupsByNameList]);
      resetGroupSettingByNameState();
    }
  }, [getGroupSettingByNameState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }
    if (row.Group.length > 0) {
      className += 'highlighted-row';
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any) => {
    if ((e.target as HTMLElement).tagName === 'INPUT') {
      e.stopPropagation();
      return;
    }
    setSelectedRow(row);
    if (selectedRow.Id === undefined || selectedRow.Id !== row.Id) {
      setOpenPanel(true);
    } else {
      setOpenPanel(!openPanel);
    }
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const refreshClickHandler = () => {
    const filter = createQueryString({
      ...filterObj,
      IsAssigned: !showGroupItems ? '' : isGroupSelected ? 'false' : 'true',
    });
    getGroupSettingsServiceHandler(filter);
    setSelectedCodeIds([]);
    setSelectedRows([]);
    closePanelHandler();
  };

  const deleteHandler = () => {
    DeleteGroupSettingService(selectedId);
  };

  const deleteClickHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setSelectedId(row.Id);
    event.stopPropagation();
    closePanelHandler();
    resetGroupSettingDetail();
    props.deletePopupToggleHandler();
  };

  const openAddGroupSettingHandler = (
    row: { Id: number },
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelHandler();
    resetGroupSettingDetail();
    setSelectedId(row.Id);
    props.addToggleHandler();
  };

  const openAddGroupCodeHandler = (
    row: { Id: number },
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelHandler();
    setSelectedId(row.Id);
    props.addGroupCodeToggleHandler();
  };

  function getFieldName(field: string): string {
    switch (field) {
      case 'TrayId':
        return 'tray_id';
      case 'OrderId':
        return 'order_id';
      case 'ProductId':
        return 'product_id';
      case 'CustomerDueDate':
        return 'customer_due_date';
      case 'Katashiki':
        return 'katashiki';
      case 'Kishu':
        return 'kishu';
      case 'IsAssigned':
        return 'is_assigned';
      default:
        return 'customer_due_date';
    }
  }

  const handleTableChange = (type: any, newState: any) => {
    if (
      newState.sortField !== columSortOrder.dataField ||
      newState.sortOrder !== columSortOrder.order ||
      !isGroupSelected
    ) {
      // if (!isGroupSelected) {
      resetGetAllGroupSettingState();
      setColumnSortOrder({
        ...columSortOrder,
        dataField: newState.sortField,
        order: newState.sortOrder,
      });
      const filter = createQueryString({
        ...filterObj,
        Column: newState.sortField,
        Order: newState.sortOrder,
        IsAssigned: !showGroupItems ? '' : isGroupSelected ? 'false' : 'true',
      });
      getGroupSettingsServiceHandler(filter);
      // }
    }
  };

  // useEffect(() => {
  //   const filter = createQueryString({
  //     ...filterObj,
  //     Column: columSortOrder.dataField,
  //     Order: columSortOrder.order,
  //   });

  //   getGroupSettingsServiceHandler(filter);
  // }, [columSortOrder]);

  const filterHandler = (object: IGroupFilter) => {
    const filter = createQueryString({
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });
    getGroupSettingsServiceHandler(filter, true);
    setFilterObj({
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });
    props.filterPopupToggleHandler();
    closePanelHandler();
    setIsFilterCleared(false);
  };

  const filterParams = (obj: IGroupFilter, isfilterCleard: boolean) => {
    const filter = createQueryString({
      ...obj,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });

    if (isfilterCleard) {
      setFilterObj({ ...obj });
      getGroupSettingsServiceHandler(filter);
      closePanelHandler();
      setIsFilterCleared(true);
    } else {
      setFilterObj({ ...obj });
    }
    props.filterPopupToggleHandler();

    // select all checkbox remain checked when we clear the filter.
    // setSelectedCodeIds([]);
    setSelectedRows([]);
  };
  // const handleSelectAllLeft = (event) => {
  //   setAllGroupSettingsListData((prevData) =>
  //     prevData.map((item) => {
  //       return { ...item, isSelected: event.target.checked };
  //     })
  //   );

  //   setSelectedCodeIds((prev) => {
  //     if (event.target.checked) {
  //       return [...prev, ...allGroupSettingsListData];
  //     } else {
  //       return [];
  //     }
  //   });

  //   setSelectedRows((prevData) =>
  //     event.target.checked
  //       ? allGroupSettingsListData.filter(
  //           (item) => item.Group.length === 0 || showGroupItems
  //         )
  //       : []
  //   );
  // };

  // const handleSelectAllRight = (event) => {
  //   setSelectedGroupSettingDetails((prevData) =>
  //     prevData.map((item) => ({ ...item, isSelected: event.target.checked }))
  //   );

  //   setRightSelectedData((prev) => {
  //     if (event.target.checked) {
  //       return [
  //         ...prev,
  //         ...selectedGroupSettingDetails.map((m) => ({
  //           ...m,
  //           isSelected: event.target.checked,
  //         })),
  //       ];
  //     } else {
  //       return [];
  //     }
  //   });
  // };

  // const handleCheckboxChange = (row: any, event: any) => {
  //   event.stopPropagation();
  //   setAllGroupSettingsListData((prevData) => {
  //     return prevData.map((item) =>
  //       item.TrayId === row.TrayId
  //         ? { ...item, isSelected: event.target.checked }
  //         : item
  //     );
  //   });

  //   setSelectedCodeIds((prev) => {
  //     if (event.target.checked) {
  //       return [...prev, row];
  //     } else {
  //       return prev.filter((r) => r.Id !== row.Id);
  //     }
  //   });

  //   if (row.Group.length <= 0 || showGroupItems) {
  //     setSelectedRows((prev) => {
  //       const isAlreadySelected = prev.some((r) => {
  //         return r.Id === row.Id;
  //       });

  //       if (isAlreadySelected) {
  //         return prev.filter((r) => r.Id !== row.Id);
  //       }

  //       return [...prev, row];
  //     });
  //   }
  // };

  // const handleRightCheckboxChange = (row: any, event: any) => {
  //   event.stopPropagation();
  //   setSelectedGroupSettingDetails((prevData) =>
  //     prevData.map((item) =>
  //       item.TrayId === row.TrayId
  //         ? { ...item, isSelected: event.target.checked }
  //         : item
  //     )
  //   );
  //   setRightSelectedData((prev) => {
  //     const isAlreadySelected = prev.some((r) => r.Id === row.Id);

  //     if (isAlreadySelected) {
  //       return prev.filter((r) => r.Id !== row.Id);
  //     }

  //     return [...prev, row];
  //   });
  // };

  const handleGroupSelectionChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    resetGroupSettingByNameState();
    const queryString = createQueryString({
      ...filterObj,
      IsAssigned: e.target.value === 'select_all' ? 'true' : 'false',
    });

    if (e.target.value === 'select_all') {
      setIsGroupSelected(false);
    } else {
      GetGroupSettingByNameService(
        Number(getTenantIdFromLocalStorage()),
        e.target.value
      );
      setIsGroupSelected(true);
      setGroupName(e.target.value);
    }
    getGroupSettingsServiceHandler(queryString);
    resetGetAllGroupSettingState();
  };

  const toggleShowGroup = (e: any) => {
    const queryString = createQueryString({
      ...filterObj,
      IsAssigned: e.target.checked ? 'false' : '',
    });

    setSelectedCodeIds([]);
    setSelectedIds([]);
    setSelectedRows([]);
    setSelectedGroupSettingDetails([]);
    setRightSelectedData([]);
    getGroupSettingsServiceHandler(queryString);

    setShowGroupItems(!showGroupItems);
    setIsGroupSelected(e.target.checked);

    if (e.target.checked) {
      GetAllGroupSettingService(Number(getTenantIdFromLocalStorage()));
    }

    // if (selectedGroup.length > 0) {
    //   GetGroupSettingByNameService(
    //     Number(getTenantIdFromLocalStorage()),
    //     selectedGroup
    //   );
    // }

    //Sometimes the selected group details are not showing so we added this code.
    setSelectedGroupSettingDetails([...groupsByNameList]);
    if (!e.target.checked) {
      setSelectedGroupSettingDetails([]);
    }
  };

  // useEffect(() => {
  //   if (selectedGroup.length > 0)
  //     GetGroupSettingByNameService(
  //       Number(getTenantIdFromLocalStorage()),
  //       selectedGroup
  //     );
  // }, [selectedGroup]);

  useEffect(() => {
    if (
      getAllGroupNameSettingState.success &&
      allGroupOptionsData &&
      allGroupOptionsData.length > 0
    ) {
      setSelectedGroup(allGroupOptionsData[0].value);
      GetGroupSettingByNameService(
        Number(getTenantIdFromLocalStorage()),
        allGroupOptionsData[0].value
      );

      //Set the group name
      setGroupName(allGroupOptionsData[0].value);
    }
    // }, [getAllGroupNameSettingState.success]);
  }, [getAllGroupNameSettingState.success, allGroupOptionsData]);

  const getColumns = (partition: PartitionEnum) => [
    {
      dataField: 'TrayId',
      text: formatMessage('tray_id'),
      classes: 'show-Elipses',
      sort: true,
    },
    {
      dataField: 'CustomerId',
      text: formatMessage('customer_id'),
      classes: 'show-Elipses',
    },
    {
      dataField: 'OrderId',
      text: formatMessage('order_id'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'ProductName',
      text: formatMessage('product_id'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'Katashiki1',
      text: formatMessage('katashiki'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'Kishu',
      text: formatMessage('kishu'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'EndUserOrderId',
      text: formatMessage('eu_order_no'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'SubContractorName',
      text: formatMessage('sub_contractor_name'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'KeyInfo1',
      text: formatMessage('key_info_1'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'KeyInfo2',
      text: formatMessage('key_info_2'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'KeyInfo3',
      text: formatMessage('key_info_3'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'Group',
      text: formatMessage('group'),
      classes: 'show-Elipses',
    },
    {
      dataField: 'CustomerDueDate',
      text: formatMessage('customer_due_date'),
      // formatter: (cell) => {
      //   return cell && cell !== '-'
      //     ? convertNonUTCDateToLocalTimeZone(cell.toString())
      //     : '-';
      // },
      classes: 'show-Elipses',
      sort: true,
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'PlanedDueDate',
      // formatter: (cell) => {
      //   return cell && cell !== '-'
      //     ? convertNonUTCDateToLocalTimeZone(cell.toString())
      //     : '-';
      // },
      text: formatMessage('planned_due_dates'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
      hidden: true,
    },
    {
      dataField: 'Code',
      text: formatMessage('code'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
  ];

  const moveSelectedToRight = () => {
    const moveableRows = allGroupSettingsListData.filter((item) =>
      selectedCodeIds.includes(item.Id)
    );

    setSelectedGroupSettingDetails((prev) => [
      ...prev,
      ...moveableRows.map((m) => ({ ...m, isSelected: false })),
    ]);

    setAllGroupSettingsListData((prev) =>
      prev.filter((item) => !selectedCodeIds.includes(item.Id))
    );

    setSelectedIds([]);
    setSelectedCodeIds([]);
  };

  const moveSelectedToLeft = () => {
    const moveableRows = selectedGroupSettingDetails.filter((item) =>
      selectedRightIds.includes(item.Id)
    );

    const updatedMoveableRows = moveableRows.map((m) => ({
      ...m,
      Group: '',
      isSelected: false,
    }));

    setAllGroupSettingsListData((prev) => [...prev, ...updatedMoveableRows]);

    setSelectedGroupSettingDetails((prev) =>
      prev.filter((item) => !selectedRightIds.includes(item.Id))
    );

    setSelecteRightIds([]);
  };

  // Build nonSelectable dynamically
  const nonSelectableIds = allGroupSettingsListData
    .filter((row) => {
      const isGroupAssigned = row.Group.length > 0;
      const isSelected = selectedIds.includes(row.Id);
      const selectionLimitReached =
        selectedIds.length + selectedGroupSettingDetails.length >=
        MAX_RECORDS_LENGTH;

      // Disable if group is assigned or selection limit reached and it's not already selected
      return selectionLimitReached && !isSelected; // isGroupAssigned || (selectionLimitReached && !isSelected);
    })
    .map((row) => row.Id);

  const selectRowLeft = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: selectedCodeIds,
    hideSelectColumn: isGroupActive && showGroupItems,
    selectionRenderer: ({ mode, checked, disabled }: any) => (
      <input
        type={mode}
        checked={checked}
        disabled={disabled}
        className="form-check-input"
        readOnly
      />
    ),
    selectionHeaderRenderer: ({ checked, indeterminate }: any) => (
      <input
        type="checkbox"
        checked={checked}
        ref={(input: HTMLInputElement | null) => {
          if (input) input.indeterminate = indeterminate;
        }}
        className="form-check-input"
        readOnly
      />
    ),
    // selectable: (row) => {
    //   const isGroupFree = row.Group.length === 0;
    //   const isAlreadySelected = selectedIds.includes(row.Id);
    //   const underLimit = selectedIds.length < MAX_RECORDS_LENGTH;
    //   return true;
    // },
    nonSelectable: isGroupSelected ? nonSelectableIds : [],
    onSelect: (row, isSelect) => {
      if (isSelect) {
        setSelectedCodeIds((prev) => [...prev, row.Id]);
      } else {
        setSelectedCodeIds((prev) => prev.filter((id) => id !== row.Id));
      }
      if (row.Group.length === 0) {
        if (isSelect) {
          setSelectedIds((prev) => [...prev, row.Id]);
        } else {
          setSelectedIds((prev) => prev.filter((id) => id !== row.Id));
        }
      }
    },

    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        setSelectedCodeIds(rows.map((item) => item.Id));
      } else {
        setSelectedCodeIds([]);
      }
      const selectableRows = rows.filter((row) => row.Group.length === 0);
      if (isSelect) {
        setSelectedIds(selectableRows.map((row) => row.Id));
      } else {
        setSelectedIds([]);
      }
    },
  };

  const selectRowRight = {
    mode: 'checkbox',
    clickToSelect: true,
    hideSelectColumn: isGroupActive,
    selected: selectedRightIds,
    selectionRenderer: ({ mode, checked, disabled }: any) => (
      <input
        type={mode}
        checked={checked}
        disabled={disabled}
        className="form-check-input"
        readOnly
      />
    ),
    selectionHeaderRenderer: ({ checked, indeterminate }: any) => (
      <input
        type="checkbox"
        checked={checked}
        ref={(input: HTMLInputElement | null) => {
          if (input) input.indeterminate = indeterminate;
        }}
        className="form-check-input"
        readOnly
      />
    ),
    nonSelectable: isGroupActive
      ? selectedGroupSettingDetails.map((row) => row.Id)
      : [],
    onSelect: (row, isSelect) => {
      if (isSelect) {
        setSelecteRightIds((prev) => [...prev, row.Id]);
      } else {
        setSelecteRightIds((prev) =>
          prev.filter((TrayId) => TrayId !== row.Id)
        );
      }
    },

    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        const allIds = rows.map((row) => row.Id);
        setSelecteRightIds(allIds);
      } else {
        setSelecteRightIds([]);
      }
    },
  };

  return (
    <>
      {props.showAddGroupSettingPopup && (
        <AddEditGroupSetting
          id={selectedId}
          modalClosed={props.addToggleHandler}
          selectedRows={selectedIds}
        />
      )}
      {props.showAddGroupCodePopup && (
        <AddEditCode
          id={selectedId}
          modalClosed={props.addGroupCodeToggleHandler}
          selectedAssignedRows={selectedCodeIds}
        />
      )}
      {props.showDeletePopup && (
        <DeletePopup
          title="delete_group_setting"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_group_setting_confirm"
          isLoading={deleteGroupSettingState.inProgress}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <Header
            className="col-lg-4 col-md-6 col-sm-6 col-xl-4"
            label="group_management"
          />
          <div className="col-lg-8 col-md-6 col-sm-6 col-xl-8">
            <ul className="add-list">
              <li>
                <FilterComponent
                  initialValues={filterObj}
                  id={0}
                  submitHandler={filterHandler}
                  filterParmas={filterParams}
                  onModalClosed={props.filterPopupToggleHandler}
                  isLoading={false}
                  isDisable={isGroupSelected}
                  isFilterCleared={isFilterCleared}
                  isFilterApplied={isFilterApplied}
                  setIsFilterApplied={setIsFilterApplied}
                />
              </li>
              <li
                title={formatMessage('refresh')}
                className={`${showGroupItems ? 'd-none' : ''}`}
              >
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <RefreshIcon />
                </a>
              </li>
              <li
                title={`${formatMessage('show_groups')}`}
                className="d-flex align-items-center g-2 ms-4 ps-1 show-group"
              >
                <BsForm.Check
                  type="switch"
                  id="custom-switch"
                  className="btn"
                  checked={showGroupItems}
                  readOnly
                  onClick={(e: any) => toggleShowGroup(e)}
                />
                <p className="auto-refresh text-white">
                  {formatMessage('show_groups')}
                </p>
              </li>
              {showGroupItems && (
                <li className="select-group">
                  <select
                    className="custom-select form-control"
                    value={selectedGroup}
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      setSelectedGroup(e.target.value);
                      handleGroupSelectionChange(e);
                    }}
                    disabled={
                      allGroupOptionsData.length === 0 ||
                      allGroupOptions.filter(
                        (group) => group.disabled === false
                      ).length === 0
                    }
                  >
                    {allGroupOptionsData.length !== 0 &&
                    allGroupOptions.filter((group) => group.disabled === false)
                      .length > 0 ? (
                      allGroupOptionsData.map(
                        (data: IOption, index: number) => (
                          <option
                            key={data.value}
                            value={data.value}
                            disabled={data.disabled}
                            className={`${data.disabled ? 'disabled-option' : ''}`}
                          >
                            {index == 0
                              ? formatMessage(data.value)
                              : data.value}
                          </option>
                        )
                      )
                    ) : (
                      <option
                        value={selectedGroup}
                        disabled={true}
                      >
                        {formatMessage('no_group')}
                      </option>
                    )}
                  </select>
                </li>
              )}
              {isOperationPermittedRoleBase(
                ModuleType.GroupManagement,
                'Add'
              ) &&
                !showGroupItems && (
                  <li
                    title={formatMessage('assign_group')}
                    className="select-group"
                  >
                    <a
                      className={`btn btn-primary btn-blue ${selectedIds.length >= 1 && selectedIds.length <= MAX_RECORDS_LENGTH && selectedIds.length > 0 && selectedIds.length === selectedCodeIds.length ? '' : 'disabled'} `}
                      data-toggle="modal"
                      data-testid="modalbtn"
                      data-target="#addUser"
                      onClick={(event: any) =>
                        openAddGroupSettingHandler({ Id: -1 }, event)
                      }
                    >
                      <img
                        src={assignGroup}
                        alt=""
                        className="assignCode me-2"
                      />
                      <FormattedMessage id="assign_group" />
                    </a>
                  </li>
                )}
              {!showGroupItems && (
                <li
                  title={formatMessage('add_group_code')}
                  className="select-group"
                >
                  <a
                    className={`btn btn-secondary ${selectedCodeIds.length > 0 ? '' : 'disabled'} `}
                    data-toggle="modal"
                    data-testid="modalbtn"
                    data-target="#addUser"
                    onClick={(event: any) =>
                      openAddGroupCodeHandler({ Id: -1 }, event)
                    }
                  >
                    <img
                      src={assignCode}
                      alt=""
                      className="assignCode me-2"
                    />
                    <FormattedMessage id="add_group_code" />
                  </a>
                </li>
              )}
              <li>
                {isGroupSelected && (
                  <div>
                    <LoaderButton
                      className="btn-secondary save-group"
                      text="save"
                      onClick={(event: any) => {
                        var updateObj: IUpdateGroupSetting = {
                          GroupId: selectedGroupSettingDetails
                            .map((item) => item.Id)
                            .join(','),
                          TenantId: Number(getTenantIdFromLocalStorage()),
                          GroupName: groupName,
                        };
                        UpdateGroupSettingService(updateObj);
                        setSelectedCodeIds([]);
                        setSelectedIds([]);
                      }}
                      disabled={isGroupActive || allGroupOptions.length === 0}
                    />
                  </div>
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page">
          {(getAllGroupSettingState.inProgress ||
            groupSettingState.inProgress ||
            deleteGroupSettingState.inProgress ||
            getGroupSettingByNameState.inProgress ||
            addUpdateGroupSettingState.inProgress) && (
            <FormLoader
              loading={
                getAllGroupSettingState.inProgress ||
                groupSettingState.inProgress ||
                deleteGroupSettingState.inProgress ||
                getGroupSettingByNameState.inProgress ||
                addUpdateGroupSettingState.inProgress
              }
            />
          )}
          {
            <div className="row">
              <div
                className={`${isGroupSelected === true && allGroupOptionsData.length > 0 && allGroupOptions.filter((group) => group.disabled === false).length > 0 ? 'col-6 group-table' : 'col-12'}`}
              >
                {allGroupSettingsListData &&
                allGroupSettingsListData.length > 0 ? (
                  <div>
                    {allGroupSettingsListData &&
                      allGroupSettingsListData.length > 0 && (
                        <>
                          <div className="tableDesign row-eq-height tableDevices p-3 changingPanel ">
                            <div
                              className="table-responsive"
                              data-testid="table"
                            >
                              {allGroupSettingsListData && (
                                <Grid
                                  data={allGroupSettingsListData}
                                  columns={getColumns(PartitionEnum.left)}
                                  keyField="Id"
                                  loading={false}
                                  rowClasses={rowClassFormat}
                                  hover={true}
                                  sort={columSortOrder}
                                  selectRow={selectRowLeft}
                                  remote={{ sort: true }}
                                  onTableChange={handleTableChange}
                                />
                              )}
                            </div>
                          </div>

                          {allGroupSettingsListData.length > 0 ? (
                            <div className="row no-gutters p-3 pt-0 tableFooter">
                              <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                                <FormattedMessage id="show" />
                                <select
                                  data-testid="pageSelect"
                                  className="pageLimit"
                                  onChange={onPageLimitChanged}
                                  value={pageLimitInfo.pageLimit}
                                >
                                  {pageLimitOptions.map((option: any) => (
                                    <option
                                      key={option}
                                      value={option}
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                                <Pagination
                                  isRefreshPage={false}
                                  totalPages={pageInfo.totalPages}
                                  pageLimit={pageLimitInfo.pageLimit}
                                  onPageChanged={onPageChanged}
                                  disablePagination={disablePagination}
                                  setIsRefreshPage={setIsRefreshPage}
                                  currentPage={pageInfo.currentPage}
                                  totalRecords={
                                    groupSettingList.PagingDetails.TotalRecords
                                  }
                                />
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </>
                      )}
                  </div>
                ) : (
                   <div className="message">
                    <div className="d-flex message-area">
                      <div className="no-data-img">
                        <img
                          src={noMessageIcon}
                          alt=""
                          className="no_message"
                        />
                      </div>
                      <div>
                        <h3 className="fw-bold display-6">
                          {' '}
                          <FormattedMessage id="no_group_setting" />
                        </h3>
                        <h4 className="mb-3">
                          <FormattedMessage id="no_group_setting_message" />
                        </h4>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {isGroupSelected &&
                allGroupOptionsData.length > 0 &&
                allGroupOptions.filter((group) => group.disabled === false)
                  .length > 0 && (
                  <div className="move-arrow">
                    <Button
                      onClick={moveSelectedToRight}
                      disabled={
                        isGroupActive
                          ? isGroupActive
                          : selectedIds.length +
                              selectedGroupSettingDetails.length >
                              MAX_RECORDS_LENGTH || selectedIds.length === 0
                      }
                    >
                      <RightArrowMove />
                    </Button>
                    <Button
                      onClick={moveSelectedToLeft}
                      disabled={
                        isGroupActive
                          ? isGroupActive
                          : selectedRightIds.length === 0
                      }
                    >
                      <LeftArrowMove />
                    </Button>
                  </div>
                )}

              {isGroupSelected &&
                allGroupOptionsData.length > 0 &&
                allGroupOptions.filter((group) => group.disabled === false)
                  .length > 0 && (
                  <div
                    className={`${isGroupSelected === true && allGroupOptionsData.length > 0 && allGroupOptions.filter((group) => group.disabled === false).length > 0 ? 'col-6' : 'col-12'}`}
                  >
                    {selectedGroupSettingDetails &&
                    selectedGroupSettingDetails.length > 0 ? (
                      <>
                        <div className="tableDesign row-eq-height tableDevices p-3 changingPanel group-table">
                          <div
                            className="table-responsive"
                            data-testid="table"
                          >
                            {selectedGroupSettingDetails && (
                              <Grid
                                data={selectedGroupSettingDetails}
                                columns={getColumns(PartitionEnum.right)}
                                keyField="Id"
                                loading={false}
                                rowClasses={rowClassFormat}
                                hover={true}
                                selectRow={selectRowRight}
                              />
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="message">
                        <div className="message-area">
                          <div className="no-data-img text-center">
                            <SelectedGroupNoDataIcon />
                          </div>
                          <div className="no-group-display">
                            <h3 className="fw-bold display-6">
                              {' '}
                              <FormattedMessage id="no_data" />
                            </h3>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
            </div>
          }
        </div>
      </div>
      <SlidingPanel
        type={'right'}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel">
          <div className="row bb p-2 pl-4 g-0 align-items-center ">
            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
              <h2 className="fw-bold mb-0 mt-1 ms-2 py-2">
                {selectedRow.TrayId}
              </h2>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 close-icon-detail">
              <span title={formatMessage('close')}>
                <CloseSidePanelIcon closePanelHandler={closePanelHandler} />
              </span>
            </div>
          </div>
          <div className="group_detailsWrapper pb-3">
            <GroupSettingDetails selectedRowId={selectedRow.Id} />
          </div>
        </div>
      </SlidingPanel>
    </>
  );
};

export default FilterPopupHOC(
  AddEditGroupCodePopupHOC(
    AddEditGroupSettingPopupHOC(DeletePopupHOC(observer(GroupSetting)))
  )
);
